var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 41,
    viewBox: "0 0 128 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 127.803 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 109.869 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 91.936 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 74.0028 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 56.0695 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 38.1362 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 20.2029 0.046875)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 127.803 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 109.869 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 91.936 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 74.0028 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 56.0695 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 38.1362 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 20.2029 17.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 127.803 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 109.869 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 91.936 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 74.0028 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 56.0695 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 38.1362 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 20.2029 35.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsN);
export default __webpack_public_path__ + "static/media/dotsN.b2930a8854d641bc3598ebad852596b2.svg";
export { ForwardRef as ReactComponent };